export default {
  path: "/report",
  name: "report",
  component: { template: `<router-view/>` },
  children: [
    {
      path: "technical/:provider?",
      name: "report/technical",
      component: () => import("@/components/Reports/Table"),
      props: {
        type: "technical"
      },
      meta: {
        can: "admin::report:technical"
      }
    },
    {
      path: "financial/:provider?",
      name: "report/financial",
      component: () => import("@/components/Reports/Table"),
      props: {
        type: "financial"
      },
      meta: {
        can: "admin::report:financial"
      }
    },
    {
      path: "transfers/:provider?",
      name: "report/transfers",
      component: () => import("@/components/Reports/Table"),
      props: {
        type: "transfers"
      },
      meta: {
        can: "admin::report:transfers"
      }
    },
    {
      path: "airtime/:provider?",
      name: "report/airtime",
      component: () => import("@/components/Reports/Table"),
      props: {
        type: "airtime"
      },
      meta: {
        can: "admin::report:airtime"
      }
    },
    {
      path: "queue",
      name: "report/queue",
      component: () => import("@/components/Reports/Queue"),
      meta: {
        can: "admin::report:queue"
      }
    },
    {
      path: "vouchers",
      name: "report/vouchers",
      component: () => import("@/components/Reports/Vouchers"),
      meta: {
        can: "admin::report:vouchers"
      }
    },
    {
      path: "monnify",
      name: "report/monnify",
      component: () => import("@/components/Reports/Monnify"),
      meta: {
        can: "admin::report:monnify"
      }
    }
  ],
  meta: {
    can: "admin::report"
  }
};



// WEBPACK FOOTER //
// ./src/router/report.js